import * as React from "react";
import { Label } from "./label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./select";
import { Clock } from "lucide-react";

interface TimePickerProps {
  label?: string;
  time?: string; // Format: "HH:mm:ss AM/PM"
  setTime?: (time: string) => void;
  error?: boolean;
}

const generateTimeOptions = () => {
  const times: any[] = [];
  const periods = ["AM", "PM"];

  for (let h = 1; h <= 12; h++) {
    for (let m = 0; m < 60; m += 15) {
      // Create time options in 15-minute intervals
      const hour = h < 10 ? `0${h}` : h;
      const minute = m === 0 ? "00" : m === 15 ? "15" : m === 30 ? "30" : "45";
      periods.forEach((period) => {
        times.push(`${hour}:${minute} ${period}`);
      });
    }
  }
  return times;
};

export function TimePicker({ label, time, setTime, error }: TimePickerProps) {
  const [selectedTime, setSelectedTime] = React.useState<string>(
    time || "12:00 AM"
  );

  const handleTimeChange = (value: string) => {
    setSelectedTime(value);
    setTime?.(value); // Pass the selected time back to the parent
  };

  const timeOptions = generateTimeOptions();

  return (
    <div className="flex flex-col gap-2">
      {label && <Label className="BookEZ_font_color_gray_2">{label}</Label>}
      <div className="relative flex items-center">
        <Select value={selectedTime} onValueChange={handleTimeChange}>
          <SelectTrigger className="w-full h-10 pl-3 pr-6 rounded border transition focus:outline-none BookEZ_input_border_radius BookEZ_card_border_color BookEZ_font_color_gray_2">
            <SelectValue />
            <div className="absolute right-3 pl-3.5 z-10 top-1/2 -translate-y-1/2 BookEZ_card_bg">
              <Clock className="h-4 w-4 opacity-50 BookEZ_font_color_gray_2" />
            </div>
          </SelectTrigger>
          <SelectContent>
            {timeOptions.map((timeOption, index) => (
              <SelectItem key={index} value={timeOption}>
                {timeOption}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}

export default TimePicker;
